
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("gnKsg", function(module, exports) {
module.exports = JSON.parse("{}");

});


//# sourceMappingURL=en-GB.3356c986.js.map
